import { Component } from '@angular/core';

/**
 * Native port of v1's `<panel>` rewrite inside `ftExpandableContent`'s
 * `secondary` slot. The AngularJS controller imperatively turned each
 * `<panel class="X" …>children</panel>` into
 * `<div class="ft-panel X" …><div class="ft-panel-bg"></div>
 * <div class="ft-panel-content">children</div></div>` and appended them to a
 * generated `.ft-secondary-area`
 * (account-v2/.../components/expandable-content/expandableContent.directive.ts).
 *
 * Here the component host IS the `.ft-panel`: `selector: 'panel'`, host class
 * `ft-panel`. Consumer-supplied classes (`addnew`/`variation`/`intro`) merge
 * onto the host automatically, and `(click)` / `[hidden]` / `ft-targets-modal`
 * land on the host element exactly as v1 copied them — no imperative attribute
 * shuffling. The lone deviation is the host tag (`<panel>` vs v1's `<div>`);
 * every expandable/secondary-area CSS selector is class-based (`.ft-panel`,
 * `.ft-panel-content`, …), so the rendered result is visually identical.
 */
@Component({
    selector: 'panel',
    host: { class: 'ft-panel' },
    templateUrl: './panel.component.html',
    standalone: false
})
export class PanelComponent {}
